import type { CanvasElement } from '@extapia/shared';
import { boundsOf, mergeBounds } from '@extapia/shared';
import { createRoughGen, drawElement } from '@extapia/canvas';

// Client-side export: render elements to an offscreen canvas and download.

export const exportToPNG = (elements: CanvasElement[], background: string, padding = 24): void => {
  const alive = elements.filter((e) => !e.isDeleted);
  if (alive.length === 0) return;
  const merged = mergeBounds(alive.map(boundsOf));
  if (!merged) return;

  const w = Math.max(1, merged.x2 - merged.x1 + padding * 2);
  const h = Math.max(1, merged.y2 - merged.y1 + padding * 2);

  const canvas = document.createElement('canvas');
  const dpr = window.devicePixelRatio || 1;
  canvas.width = w * dpr;
  canvas.height = h * dpr;
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  ctx.scale(dpr, dpr);

  ctx.fillStyle = background;
  ctx.fillRect(0, 0, w, h);

  ctx.translate(-merged.x1 + padding, -merged.y1 + padding);
  const rc = createRoughGen(canvas);
  for (const el of alive) {
    drawElement(ctx, rc, el);
  }

  canvas.toBlob((blob) => {
    if (!blob) return;
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `excalidraw-extapia-${Date.now()}.png`;
    a.click();
    URL.revokeObjectURL(url);
  }, 'image/png');
};
